
import { DiverseLedger } from "@/models/base";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";
import { printHumanFloat } from "@/utils/pretty-print";
export default Vue.extend({
	data(){
		return {
			loaded: false,
			selectedItems: [] as DiverseLedger[],
		};
	},
	props: {
		selectedItem: {
			type: Object as ()=>DiverseLedger
		},
		ledgers: {
			type: Array as ()=>DiverseLedger[]
		}
	},
	computed: {
		// eslint-disable-next-line max-lines-per-function
		cols():IDataTableColumn[]{
			let result = ( [
				{
					name: this.$ct("code").toString(),
					property: "LedgerCode",
					width: "80px"
				},
				{
					name: this.$ct("description").toString(),
					property: "LedgerAccount.Description",
					width: "200px",
				},
				{
					name: this.$ct("debet").toString(),
					property: "Debet",
					width: "80px",
					right: true,
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("credit").toString(),
					property: "Credit",
					width: "80px",
					right: true,
					print(value:number):string{
						return printHumanFloat(value);
					}
				},
				{
					name: this.$ct("comment").toString(),
					property: "Comment",
					width: "280px"
				}
			] as IDataTableColumn[]).map((c:IDataTableColumn)=>{
				c.disableSorting = true;
				return c;
			});
			return result;
		},
		compareFunction():(a:DiverseLedger, b:DiverseLedger)=>boolean{
			return (a:DiverseLedger, b:DiverseLedger):boolean => {
				return a==b;
			};
		},
	},
	watch: {
		selectedItems: {
			deep: true,
			handler(){
				console.log("WATCH SELECTED",this.selectedItems.length);
				if (this.selectedItems.length > 1) {
					this.selectedItems.splice(0, this.selectedItems.length-1);
				}
				if (this.selectedItems.length == 1 && this.selectedItems[0] != this.selectedItem) {
					this.$emit("select", this.selectedItems[0]);
				}
			}
		},
		selectedItem: {
			immediate: true,
			handler(){
				this.emptySelectedItems();
				this.selectedItems.push(this.selectedItem);
			}
		},
		"purchase.Ledgers": {
			handler(){
				this.selectedItems.splice(0, this.selectedItems.length);
			}
		},
	},
	methods: {
		emptySelectedItems(){
			this.selectedItems.splice(0, this.selectedItems.length);
		},
		onClick(p:DiverseLedger){
			let i = this.selectedItems.indexOf(p);
			this.emptySelectedItems();
			if (i != -1) return;
			this.$emit("select", p);
		}
	},
	async mounted(){
		if(this.selectedItem){
			this.selectedItems=[];
			this.selectedItems.push(this.selectedItem);
			console.log(this.selectedItems);
		}
		this.loaded = true;
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	},
});
